import {ChangeDetectionStrategy, Component, computed, input, output} from '@angular/core';
import {CompetitorArticleDta, SelectDeselectData} from "../../types/competitor-article-sync.types";
import {MatAnchor} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {competitorArticleParamsData} from "../../configs/competitro-article-sync-tabs";
import {MatCheckbox} from "@angular/material/checkbox";

@Component({
  selector: 'div[app-competitor-article-sync-card]',
  imports: [
    MatAnchor,
    MatIcon,
    MatCheckbox
  ],
  templateUrl: './competitor-article-sync-card.component.html',
  styleUrl: './competitor-article-sync-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompetitorArticleSyncCardComponent {
  competitorArticle = input.required<CompetitorArticleDta>();
  btnKey = input<string>('');
  selectedData = input<Array<number>>([]);
  handleSelectData = output<SelectDeselectData>();

  public readonly competitorArticleParamsData = competitorArticleParamsData;

  public isSelected = computed(() => this.selectedData()?.find(i => i === this.competitorArticle().id));

  public getParamData(key: string): string {
    return this.competitorArticle()[key]?.toString() || 'Не установлен';
  }

  public handleUpdateChecked(completed: boolean): void {
    this.handleSelectData.emit({
      id: this.competitorArticle().id,
      completed: completed
    });
  }
}
